import { CONFIG } from 'src/config-global';
import { useLocales } from 'src/locales/use-locales';

type PageSeoProps = {
  path: string;
  title: string;
  description: string;
};

export function PageSeo({ path, title, description }: PageSeoProps) {
  const { currentLang } = useLocales();

  const url = `${CONFIG.siteUrl}${path}`;
  const image = `${CONFIG.siteUrl}/somnus.svg`;

  return (
    <>
      <title>{title}</title>
      <meta name="description" content={description} />
      <meta name="robots" content="index,follow" />
      <link href={url} rel="canonical" />
      <meta content="website" property="og:type" />
      <meta property="og:locale" content={currentLang.ogLocale} />
      <meta property="og:site_name" content={CONFIG.siteName} />
      <meta content={title} property="og:title" />
      <meta content={description} property="og:description" />
      <meta content={url} property="og:url" />
      <meta content={image} property="og:image" />
      <meta content="summary" name="twitter:card" />
      <meta content={title} name="twitter:title" />
      <meta content={description} name="twitter:description" />
    </>
  );
}
